import Users from "layouts/users";
import Orders from "layouts/orders";
import SignIn from "layouts/authentication/sign-in";
import Products from "layouts/products";
import Mosques from "layouts/mosques";
import Categories from "layouts/categories";
import Supply from "layouts/supply";
import Icon from "@mui/material/Icon";
import Cookies from "js-cookie";

const authToken = Cookies.get("authToken");
const userRole = Cookies.get("userRole");

// Default routes for backward compatibility
const routes = [
  {
    type: "collapse",
    name: "المستخدمون",
    key: "users",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/users",
    component: <Users />,
  },
  {
    type: "collapse",
    name: "المنتجات",
    key: "products",
    icon: <Icon fontSize="small">shopping_cart</Icon>,
    route: "/products",
    component: <Products />,
  },
  {
    type: "collapse",
    name: "الفئات",
    key: "categories",
    icon: <Icon fontSize="small">category</Icon>,
    route: "/categories",
    component: <Categories />,
  },
  {
    type: "collapse",
    name: "المساجد",
    key: "mosques",
    icon: <Icon fontSize="small">mosque</Icon>,
    route: "/mosques",
    component: <Mosques />,
  },
  {
    type: "collapse",
    name: "الطلبات",
    key: "orders",
    icon: <Icon fontSize="small">attach_money</Icon>,
    route: "/orders",
    component: <Orders />,
  },
  {
    type: "collapse",
    name: "التوريد",
    key: "supply",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/supply",
    component: <Supply />,
  },
  {
    type: "collapse",
    name: authToken ? "تسجيل الخروج" : "تسجيل الدخول",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    // Signed-in users go through the real sign-out route (clears cookies);
    // pointing "sign out" straight at the sign-in form never ended the session.
    route: authToken ? "/authentication/sign-out" : "/authentication/sign-in",
    component: <SignIn />,
  },
];

export const getRoutes = (t) => {
  // Fallback function to handle cases where translation is not ready
  const translate = (key, fallback) => {
    try {
      return t && typeof t === 'function' ? t(key) : fallback;
    } catch (error) {
      console.warn('Translation error:', error);
      return fallback;
    }
  };

  try {
    const routesArray = [
      {
        type: "collapse",
        name: translate("navigation.users", "المستخدمون"),
        key: "users",
        icon: <Icon fontSize="small">table_view</Icon>,
        route: "/users",
        component: <Users />,
      },
      {
        type: "collapse",
        name: translate("navigation.products", "المنتجات"),
        key: "products",
        icon: <Icon fontSize="small">shopping_cart</Icon>,
        route: "/products",
        component: <Products />,
      },
      {
        type: "collapse",
        name: translate("navigation.categories", "الفئات"),
        key: "categories",
        icon: <Icon fontSize="small">category</Icon>,
        route: "/categories",
        component: <Categories />,
      },
      {
        type: "collapse",
        name: translate("navigation.mosques", "المساجد"),
        key: "mosques",
        icon: <Icon fontSize="small">mosque</Icon>,
        route: "/mosques",
        component: <Mosques />,
      },
      {
        type: "collapse",
        name: translate("navigation.orders", "الطلبات"),
        key: "orders",
        icon: <Icon fontSize="small">attach_money</Icon>,
        route: "/orders",
        component: <Orders />,
      },
      {
        type: "collapse",
        name: translate("navigation.supply", "التوريد"),
        key: "supply",
        icon: <Icon fontSize="small">inventory</Icon>,
        route: "/supply",
        component: <Supply />,
      },
      {
        type: "collapse",
        // Read the cookie at render time: the module-scope value goes stale
        // after login/logout, leaving the label (and target) wrong until a
        // full reload.
        name: Cookies.get("authToken")
          ? translate("navigation.signOut", "تسجيل الخروج")
          : translate("navigation.signIn", "تسجيل الدخول"),
        key: "sign-in",
        icon: <Icon fontSize="small">login</Icon>,
        route: Cookies.get("authToken") ? "/authentication/sign-out" : "/authentication/sign-in",
        component: <SignIn />,
      },
    ];
    
    // console.log('getRoutes called with t:', typeof t, 'routesArray length:', routesArray.length);
    return routesArray;
  } catch (error) {
    console.error('Error in getRoutes:', error);
    // Return default routes as fallback
    return routes;
  }
};

export default routes;
